export const DEFAULT_ACCORDION_EXCLUSIVE_PROP = false;
export const DEFAULT_ACCORDION_STYLED_PROP = true;
